module.exports = __webpack_public_path__ + "static/media/react.4fa9f7c2.svg";